module.exports = __webpack_public_path__ + "img/center-info-structure2.d6630451.png";